import React, { useState, useEffect } from "react";
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Box,
    TextField,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/material/styles";
import { ResourceLinks } from "../../../../constants";
import { floatOnly } from "../../../../utils";

const CustomAccordion = styled(Accordion)(({ theme }) => ({
    "&:before": {
        display: "none",
    },
    "&.MuiAccordion-root.Mui-expanded": {
        marginTop: 0,
        marginBottom: 0,
    },
}));

const CustomAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
    backgroundColor: "rgb(217, 217, 217)",
    borderBottom: "none",
    "&.Mui-expanded": {
        backgroundColor: "rgb(0, 176, 240)",
        borderBottom: "10px solid rgb(0, 133, 180)",
    },
}));

export default function WebNumeracyOption({ question, onAnswer = () => {} }) {
    const questionData = question;

    const imagesResources = ResourceLinks.llnQuizImage;

    const [expanded, setExpanded] = useState("panel1");
    const [answer, setAnswer] = useState(questionData.data.initialState);

    // every time question change we will set to reset needed to reset
    useEffect(() => {
        setExpanded("panel1");
        setAnswer(questionData.data.initialState);
    }, [question, questionData]);

    const handleSelectOption = (key, option) => {
        let ans = {};
        ans[key]=  option.value;

        const newAnswer = { ...answer, ...ans };
        setAnswer(newAnswer);
        checkCanProceed(newAnswer);
    }

    const handleOptionValue = (key, option, e) => {
        if (floatOnly(e.target.value) || e.target.value === "") {
            const value = e.target.value;
            processAnswer(key, option, value);
        }
    };

    const processAnswer = (key, option, value) => {
        let ans = {...answer};
        ans[option][key]= value.toString();

        const newAnswer = { ...answer, ...ans };
        setAnswer(newAnswer);
        checkCanProceed(newAnswer);
    }

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const checkCanProceed = (ans) => {
        let canProceed = false;
        if (ans[questionData.data.answerSection.stateKey] !== "") {
            canProceed = true;
        }

        // for options
        if (!canProceed) {
            // for options 1
            const answerOption1 = ans[questionData.data.option1.stateKey];
            const answerKeysOption1 = Object.keys(answerOption1);
            answerKeysOption1.map((keys) => {
                if (answerOption1[keys] !== "" && answerOption1[keys] !== null) {
                    canProceed = true;
                }
                return null;
            });

            // for options 2
            const answerOption2 = ans[questionData.data.option2.stateKey];
            const answerKeysOption2 = Object.keys(answerOption2);
            answerKeysOption2.map((keys) => {
                if (answerOption2[keys] !== "" && answerOption2[keys] !== null) {
                    canProceed = true;
                }
                return null;
            });
        }

        onAnswer({
            canProceed,
            answer: ans
        });
    }

    return (
        <Box sx={{ maxWidth: 1100, margin: "0 auto", padding: "20px" }}>
            {/* Option 1 Accordion */}
            <CustomAccordion
                expanded={expanded === "panel1"}
                onChange={handleChange("panel1")}
            >
                <CustomAccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="scenario-content"
                    id="scenario-header"
                >
                    <Typography sx={{ fontSize: "20px", fontWeight: "700" }}>
                        {questionData.data.option1.title}
                    </Typography>
                </CustomAccordionSummary>
                <AccordionDetails>
                    <Box
                        display="flex"
                        flexDirection="row"
                        flexWrap="wrap"
                        alignItems="left"
                        justifyContent="space-around"
                        borderTop="10px solid rgb(191, 191, 191)"
                        sx={{
                            textAlign: "left",
                            padding: "10px"
                        }}
                    >
                        <Box sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            height: "420px",
                            width: "1060px",
                            fontSize: "26px",
                            textAlign: "left",
                        }}>
                            <Box sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                fontSize: "26px",
                                textAlign: "left"
                            }}>
                                <ul>
                                    <li>{questionData.data.option1.optionsInfo.header}</li>
                                    <ul>
                                        {questionData.data.option1.optionsInfo.options.map((option, index) => (
                                            <li key={index}>{option}</li>
                                        ))}
                                    </ul>
                                </ul>
                                <Box component="img" 
                                    src={`${imagesResources}${questionData.data.option1.image.src}`}
                                    sx={{
                                        width: "278px",
                                        height: "133px",
                                    }}
                                    alt="Img Question Option 1"
                                />
                            </Box>

                            <Box sx={{
                                display: "flex",
                                justifyContent: "space-around",
                                fontSize: "26px",
                                textAlign: "left"
                            }}>
                                {/* For Cost Fields */}
                                {questionData.data.option1.answerInputs.map((input, index) => (
                                    <Box key={index} 
                                        sx={{
                                        width: "280px",
                                        borderBottomWidth: "6px",
                                        fontSize: "18px",
                                        borderBottom: "10px solid #0084B4",
                                        textAlign: "left",
                                    }}>
                                        <Box sx={{
                                            textAlign: "center",
                                            borderBottomWidth: "5px",
                                            padding: "3px",
                                            fontWeight: "bold",
                                            backgroundColor: "#00B0F0",
                                            color: "black",
                                            borderBottomStyle: "solid",
                                            borderBottomColor: "#0084B4",
                                            fontSize: "1.25em",
                                        }}>{input.value}</Box>
                                            <Box sx={{
                                                backgroundColor: "#f2f2f2",
                                                padding: "10px",
                                                fontSize: "10px",
                                                textAlign: "left",
                                            }}>
                                                <Box
                                                sx={{
                                                    borderRadius: "5px",
                                                    borderBottom: "10px solid rgb(91, 105, 107)",
                                                    backgroundColor: "rgb(122, 140, 142)",
                                                    padding: "8px",
                                                    marginBottom: "20px",
                                                    width: "260px",
                                                    margin: "0 auto",
                                                    textAlign: "left",
                                                }}
                                            >
                                                <Typography
                                                    variant="body1"
                                                    sx={{
                                                        color: "white",
                                                        marginBottom: "8px",
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    Answer:
                                                </Typography>
                                                <TextField
                                                    value={answer[questionData.data.option1.stateKey][input.stateKey]}
                                                    variant="outlined"
                                                    type="text"
                                                    onChange={(event) => handleOptionValue(input.stateKey, questionData.data.option1.stateKey, event)}
                                                    InputProps={{
                                                        startAdornment: "$",
                                                        autoComplete: "off",
                                                        // endAdornment: ".00",
                                                    }}
                                                    sx={{
                                                        width: "100%",
                                                        backgroundColor: "white",
                                                        borderRadius: "5px",
                                                    }}
                                                />
                                            </Box>
                                        </Box>
                                    </Box>
                                ))}
                            </Box>
                        </Box>
                    </Box>
                </AccordionDetails>
            </CustomAccordion>

            {/* OPtion 2 Accordion */}
            <CustomAccordion
                expanded={expanded === "panel2"}
                onChange={handleChange("panel2")}
            >
                <CustomAccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="scenario-content"
                    id="scenario-header"
                >
                    <Typography sx={{ fontSize: "20px", fontWeight: "700" }}>
                        {questionData.data.option2.title}
                    </Typography>
                </CustomAccordionSummary>
                <AccordionDetails>
                    <Box
                        display="flex"
                        flexDirection="row"
                        flexWrap="wrap"
                        alignItems="left"
                        justifyContent="space-around"
                        borderTop="10px solid rgb(191, 191, 191)"
                        sx={{
                            textAlign: "left",
                            padding: "10px"
                        }}
                    >
                        <Box sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            height: "420px",
                            width: "1060px",
                            fontSize: "26px",
                            textAlign: "left",
                        }}>
                            <Box sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                fontSize: "26px",
                                textAlign: "left"
                            }}>
                                <ul>
                                    <li>{questionData.data.option2.optionsInfo.header}</li>
                                    <ul>
                                        {questionData.data.option2.optionsInfo.options.map((option, index) => (
                                            <li key={index}>{option}</li>
                                        ))}
                                    </ul>
                                </ul>
                                <Box component="img" 
                                    src={`${imagesResources}${questionData.data.option2.image.src}`}
                                    sx={{
                                        width: "278px",
                                        height: "133px",
                                    }}
                                    alt="Img Question Option 2"
                                />
                            </Box>

                            <Box sx={{
                                display: "flex",
                                justifyContent: "space-around",
                                fontSize: "26px",
                                textAlign: "left"
                            }}>
                                {/* For Cost Fields */}
                                {questionData.data.option2.answerInputs.map((input, index) => (
                                    <Box key={index} 
                                        sx={{
                                        width: "280px",
                                        borderBottomWidth: "6px",
                                        fontSize: "18px",
                                        borderBottom: "10px solid #0084B4",
                                        textAlign: "left",
                                    }}>
                                        <Box sx={{
                                            textAlign: "center",
                                            borderBottomWidth: "5px",
                                            padding: "3px",
                                            fontWeight: "bold",
                                            backgroundColor: "#00B0F0",
                                            color: "black",
                                            borderBottomStyle: "solid",
                                            borderBottomColor: "#0084B4",
                                            fontSize: "1.25em",
                                        }}>{input.value}</Box>
                                            <Box sx={{
                                                backgroundColor: "#f2f2f2",
                                                padding: "10px",
                                                fontSize: "10px",
                                                textAlign: "left",
                                            }}>
                                                <Box
                                                sx={{
                                                    borderRadius: "5px",
                                                    borderBottom: "10px solid rgb(91, 105, 107)",
                                                    backgroundColor: "rgb(122, 140, 142)",
                                                    padding: "8px",
                                                    marginBottom: "20px",
                                                    width: "260px",
                                                    margin: "0 auto",
                                                    textAlign: "left",
                                                }}
                                            >
                                                <Typography
                                                    variant="body1"
                                                    sx={{
                                                        color: "white",
                                                        marginBottom: "8px",
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    Answer:
                                                </Typography>
                                                <TextField
                                                    value={answer[questionData.data.option2.stateKey][input.stateKey]}
                                                    variant="outlined"
                                                    type="text"
                                                    onChange={(event) => handleOptionValue(input.stateKey, questionData.data.option2.stateKey, event)}
                                                    InputProps={{
                                                        startAdornment: "$",
                                                        // endAdornment: ".00",
                                                        autoComplete: "off",
                                                    }}
                                                    sx={{
                                                        width: "100%",
                                                        backgroundColor: "white",
                                                        borderRadius: "5px",
                                                    }}
                                                />
                                            </Box>
                                        </Box>
                                    </Box>
                                ))}
                            </Box>
                        </Box>
                    </Box>
                </AccordionDetails>
            </CustomAccordion>

            {/* Answer Accordion */}
            <CustomAccordion
                expanded={expanded === "panel3"}
                onChange={handleChange("panel3")}
            >
                <CustomAccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="answer-content"
                    id="answer-header"
                >
                    <Typography sx={{ fontSize: "20px", fontWeight: "700" }}>
                        {questionData.data.answerSection.title}
                    </Typography>
                </CustomAccordionSummary>
                <AccordionDetails>
                    <Box
                        display="flex"
                        flexDirection="row"
                        flexWrap="wrap"
                        alignItems="center"
                        justifyContent="space-around"
                        borderTop="10px solid rgb(191, 191, 191)"
                    >
                        <Box sx={{
                            textAlign: "center",
                            height: "400px",
                            width: "1060px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-evenly",
                            fontSize: "26px",
                        }}>
                            <h2>{questionData.data.answerSection.question}</h2>
                            <Box sx={{
                                display: "flex",
                                justifyContent: "space-around",
                            }}>
                                {questionData.data.answerSection.options.map((option, index) => (
                                    <Box component="img" key={index} src={`${imagesResources}${option.image}`} alt={`Img Question ${index}`}/>
                                ))}
                            </Box>
                            <Box sx={{
                                display: "flex",
                                justifyContent: "space-around",
                                textAlign: "center",
                                fontSize: "26px",
                            }}>
                                {questionData.data.answerSection.options.map((option, index) => (
                                    <span key={index} 
                                        style={{
                                            width: "235px",
                                            height: "50px",
                                            display: "inline-table",
                                            cursor: "pointer",
                                            userSelect: "none",
                                            backgroundColor: answer[questionData.data.answerSection.stateKey] === option.value ? "#afe23e" :"#dadada",
                                            borderBottom: answer[questionData.data.answerSection.stateKey] === option.value ? "10px solid #639729" :"10px solid #808080",
                                            fontWeight: "bold",
                                            textAlign: "center",
                                            fontSize: "26px",
                                        }}
                                        onClick={() => handleSelectOption(questionData.data.answerSection.stateKey, option)}
                                    >{option.value}</span>
                                ))}
                            </Box>
                        </Box>
                    </Box>
                </AccordionDetails>
            </CustomAccordion>
        </Box>
    );
};